export default "__VITE_ASSET__AgzQI1iJ__"